import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const GoogleSearchHeadline = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12694"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12694)">
          <rect
            x="-3"
            width="121"
            height="112"
            rx="5.09677"
            fill="#BFCDFF"
          />
          <rect
            x="10.0664"
            y="28.0625"
            width="26.4395"
            height="43.004"
            rx="4.61895"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="18.0176"
            y="30.7703"
            width="11.239"
            height="1.27419"
            rx="0.637097"
            fill="#1E1E1E"
          />
          <rect
            x="19.6228"
            y="38.2561"
            width="57.6573"
            height="50.6492"
            rx="0.796371"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="19.145"
            y="62.625"
            width="58.6129"
            height="1.27419"
            fill="#1E1E1E"
          />
          <rect
            x="19.145"
            y="42.875"
            width="58.6129"
            height="0.955645"
            fill="#1E1E1E"
          />
          <rect
            x="23.6047"
            y="53.0686"
            width="49.0564"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <rect
            x="23.6047"
            y="57.5283"
            width="38.8629"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <rect
            x="31.25"
            y="47.9718"
            width="12.1048"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <circle
            cx="26.1531"
            cy="48.6089"
            r="2.54839"
            fill="#8C8C8C"
          />
          <circle
            cx="68.5201"
            cy="40.6452"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="71.7056"
            cy="40.6451"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="74.8909"
            cy="40.6451"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="52.9113"
            cy="70.9074"
            r="1.91129"
            fill="#0C5CEF"
          />
          <path
            d="M45.4549 70.0025C45.5184 69.9133 45.6509 69.9133 45.7144 70.0025L56.2655 84.831C56.3405 84.9365 56.2651 85.0827 56.1357 85.0827H35.0336C34.9042 85.0827 34.8288 84.9365 34.9038 84.831L45.4549 70.0025Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <path
            d="M54.6934 75.0875C54.757 74.9995 54.8881 74.9995 54.9517 75.0875L55.3341 74.8113L54.9517 75.0875L61.9879 84.83C62.064 84.9354 61.9887 85.0826 61.8588 85.0826H47.7863C47.6564 85.0826 47.5811 84.9354 47.6572 84.83L54.6934 75.0875Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="72.502"
            y="20.4174"
            width="33.4476"
            height="33.4476"
            rx="16.7238"
            fill="white"
          />
          <rect
            x="72.502"
            y="20.4174"
            width="33.4476"
            height="33.4476"
            rx="16.7238"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <g clipPath="url(#clip0_1529_12694)">
            <path
              d="M80.1332 40.6284L86.4599 29.9124C87.2635 30.3805 91.316 32.5993 91.9704 33.0213L85.6438 43.738C84.9518 44.6424 79.2566 42.0008 80.1332 40.6278V40.6284Z"
              fill="#FBBC04"
            />
            <path
              d="M98.3121 40.627L91.9855 29.9116C91.101 28.4553 89.1961 27.9261 87.6315 28.7862C86.0668 29.6463 85.5904 31.4992 86.4749 33.0205L92.8016 43.7372C93.6861 45.1929 95.591 45.722 97.1557 44.862C98.6519 44.0018 99.1966 42.0833 98.3121 40.6283V40.627Z"
              fill="#3D7FFE"
            />
            <path
              d="M82.8734 45.2759C84.6273 45.2759 86.0492 43.9041 86.0492 42.2119C86.0492 40.5196 84.6273 39.1478 82.8734 39.1478C81.1194 39.1478 79.6975 40.5196 79.6975 42.2119C79.6975 43.9041 81.1194 45.2759 82.8734 45.2759Z"
              fill="#34A853"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1529_12694">
            <rect
              width="19"
              height="19"
              fill="white"
              transform="translate(79.7258 27.6412)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
